import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '../../../../app/common/common.action';
import * as editorActions from '../../editor/editor.action';
import * as actions from './notas.action';
import { acessoPermitido } from '../../../../acessos.seguranca';
import * as acessos from '../../../../acessos.const.util';
import * as editor from '../../editor/editor.util';
import { verificarPlainTextMudou } from '../../editor/editor.util';
import NotasPage from './notas.page';
import NotasAPI from './notas.api';
import MultiNotasContainer from '../../../../app/common/multinotas/multinotas.container';
import ModalConfirmar from '@common/modalConfirmar/modalConfirmar';
import { LOCAL_STORAGE_USUARIO } from '../../../../localStorage.util';
import WebapiCommon from '../../../../app/common/util/webapi.common';
import { etapasEnum, statusEtapasEnum } from '@common/util/defaultValues';
import { errors } from '../../../error/erros';
import { editorRunat, editorUrl } from '@constants/defaultValues';
import { useIntl } from 'react-intl';
import ModalEncaminhar from '@common/modalEncaminhar/modalEncaminhar';
import { useHistory } from 'react-router-dom';
import ExamesEmAbertoContainer from '../../etapas/macroscopia/operacoes/exames/exames.container';

function NotasContainer(props) {
  const intl = useIntl();
  const history = useHistory();
  const [modalVisivel, setmodalVisivel] = useState(false);
  const [modalTitulo, setmodalTitulo] = useState('');
  const [modalConteudo, setmodalConteudo] = useState(undefined);
  const [modalSize, setmodalSize] = useState('lg');
  const [callbackAutorizar, setcallbackAutorizar] = useState(undefined);
  const [modalAutorizacaoLaudar, setmodalAutorizacaoLaudar] = useState(false);
  const [showModalCancelamento, setshowModalCancelamento] = useState(false);
  const [modalConfirmar, setmodalConfirmar] = useState(false);
  const [justificativaCancelar, setjustificativaCancelar] = useState('');
  const modalConfirmarTitulo = intl.formatMessage({id:"dashboards.examDetail.headsUp"});
  const [modalConfirmarMensagem, setmodalConfirmarMensagem] = useState('');
  const [notasFinalizada, setnotasFinalizada] = useState(false);
  const [fabNotas, setfabNotas] = useState(false);
  const [labelNotas, setlabelNotas] = useState('Notas');
  const [showModalConfirmarCancelamento, setshowModalConfirmarCancelamento] = useState(false);
  const [modalEncaminhar, setModalEncaminhar] = useState(false)
  const [tentativa, setTentativa] = useState(0)
  const [verificarTexto, setVerificarTexto] = useState(false);
  const [textoEditor, setTextoEditor] = useState('');
  const modalEncaminharType = 'ok';
  const modalConfirmarClick= useRef();
  const modalConfirmarType= useRef('confirm');
  const laudarType = useRef('pendente');
  const eventoNovaNotaRef = useRef(undefined);
  const eventoModalConfirmar = useRef(undefined);

  function useForceUpdate() {
    const [_value, setValue] = useState(0);
    return () => setValue(_value + 1);
  }

  useEffect(() => {
		window.addEventListener('message', ({ data }) => {
			if (data.value) {
				if (data.value.plain) {
					setTextoEditor(data.value.plain);
				}
			}
		});

		return () => {
			window.removeEventListener('message', null, true);
			props.commonActions.mudarStatusLaudoFaturado(false);
		}

	}, []);

  const handleResize = useForceUpdate();

  useEffect(() => {
    props.commonActions.alterarVisibilidadeAbas({});
    props.actions.atualizarNota({});
    props.actions.selectNota(false);
    document.title = 'Anatomia Patológica';

    try {
      editor.Inicializar(props, etapasEnum.NOTAS.toLowerCase());
    } catch (error) {
      let message = error.message;
      let title = '';
      let origin = `Etapa: ${etapasEnum.NOTAS}`;
      const code = 101;

      errors.map(err => {
        if (err.code === code) {
          title = err.title;
        }
        return err;
      });
      window.location.replace(
        `/error/${btoa(title)}/${btoa(message)}/${btoa(code)}/${btoa(origin)}/`
      );
    }

    const laudarEtapaRequest = {
      pendente: true,
      notificacaoCancer: false,
      exameId: props.detalhes.exameId,
      medicoSolicitante: props.detalhes.solicitante,
      medicoEtapa: props.editor.medExecutante,
      medicoRevisor: props.editor.medRevisor
    };

    props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);

    let etapa = props.detalhes.etapas.find(
      el => el.etapa.toLowerCase() === etapasEnum.NOTAS.toLowerCase()
    );

    setlabelNotas(props.detalhes.nomeExibicaoEtapaNotas);
    setnotasFinalizada(etapa && etapa.status === statusEtapasEnum.REALIZADO)

    window.addEventListener('resize', handleResize);

    setTimeout(() => {
      iniciarModal(etapa && etapa.status === statusEtapasEnum.REALIZADO);
    }, 600);

    return () => {
      editor.finalizar(props.commonActions);
    }
  }, []);

  function confirmarCancelamentoEtapas() {
    setshowModalConfirmarCancelamento(true);
  }

  function toggleModalConfirmarCancelamento() {
    setshowModalConfirmarCancelamento(false);
  }

  function cancelarEtapasPosteriores() {
    props.commonActions.showFadeCarregando(true);
    WebapiCommon.cancelarEtapasPosteriores(
      props.detalhes.laudo,
      props.etapaAtual,
      0,
      justificativaCancelar
    )
      .then((resp) => {
        if (resp.success) {
          props.commonActions.showAlerta(
            'sucesso',
            resp.data.mensagem,
            2000
          );

          WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
            (etapas) => {
              props.commonActions.atualizarStatusDasEtapasDoLaudo(
                etapas,
                props.detalhes.laudo
              );
              props.commonActions.showEditor(false);
              props.commonActions.showFadeCarregando(false);
              toggleModalCancelamento();
              toggleModalConfirmarCancelamento();
              _fechar();
            }
          )
        }
        else {
          props.commonActions.showFadeCarregando(false);
          props.commonActions.showAlerta(
            'erro',
            intl.formatMessage({id:"dashboards.examDetail.unableCancelSteps"}),
            2000
          );
          toggleModalCancelamento();
          toggleModalConfirmarCancelamento();

        }
      })
      .catch((error) => {
        props.commonActions.showFadeCarregando(false);
        props.commonActions.showAlerta(
          'erro',
          intl.formatMessage({id:"dashboards.examDetail.unableCancelSteps"}),
          2000
        );
        toggleModalCancelamento();
        toggleModalConfirmarCancelamento();
      });
  }

  function alterarFullscreen() {
    props.commonActions.preencherAtalho('ctrl+alt+f10');
  }

  function iniciarModal() {
    if (!props.editorInicializado && tentativa < 5) {
      setTentativa(tentativa + 1);
      setTimeout(() => {
        iniciarModal();
      }, 600);
    } else if (tentativa >= 5) {
      setTentativa(0);
      props.commonActions.showAlerta(
        'erro',
        `Não foi possivel iniciar os registros de ${labelNotas}`,
        2000
      );
    } else {
      props.textRtf && showModal('1');
    }
  }

  function setJustificativa(texto) {
    setjustificativaCancelar(texto);
  }

  function fechar() {
    props.commonActions.changeFecharTela(true);
    verificarPlainTextMudou();
  }

  function _fechar() {
    history.goBack();
    //props.commonActions.atualizarDetalhes(undefined);
    props.commonActions.preenhcerHistoricoInconformidades(undefined);
    props.commonActions.atualizarLarguraEditor('100%');
    props.commonActions.showEditor(false);
  }

  const fecharModalConfirmar=()=> {
    setmodalConfirmar(!modalConfirmar);
  };

  function showModal(index) {
    let componente = undefined;
    let titulo = '';
    let size = 'lg';
    eventoNovaNotaRef.current = novaNota;
    eventoModalConfirmar.current = confirmModal;

    switch (index) {
      case '1':
        componente = <MultiNotasContainer />;
        titulo = intl.formatMessage({ id: "dashboards.examDetail.notesSelectText" })
        setmodalConteudo(componente);
        setmodalTitulo(titulo);
        setmodalVisivel(true);
        setmodalSize(size);
        break;

      case '2':
        modalConfirmarType.current = ('confirm');
        modalConfirmarClick.current =  '3';
        setmodalConfirmarMensagem(intl.formatMessage({ id: 'dashboards.examDetails.launchAddendumReport' }));
        setmodalConfirmar(true);
        break

      case '3':
        modalConfirmarType.current = ('confirm');
        modalConfirmarClick.current =  '2';
        setmodalConfirmarMensagem(`Deseja lançar ${labelNotas} para o laudo já concluído e/ou liberado`);
        setmodalConfirmar(true);
        break

      case '4':
        modalConfirmarType.current = ('ok');
        modalConfirmarClick.current =  '1';
        setmodalConfirmarMensagem(intl.formatMessage({ id: 'dashboards.examDetails.doctorPerformingReport' }));
        setmodalConfirmar(true);
        break

      case '5':
        modalConfirmarType.current = ('ok');
        modalConfirmarClick.current =  '1';
        setmodalConfirmarMensagem(intl.formatMessage({ id: 'dashboards.examDetails.medicalReportReviewer' }));
        setmodalConfirmar(true);
        break

      case '6':
        setmodalConfirmarMensagem(intl.formatMessage({ id: 'dashboards.examDetail.notTyped' }));
        modalConfirmarType.current = ('ok');
        modalConfirmarClick.current =  '1';
        setmodalConfirmar(true);
        break

      case '7':
        setmodalConfirmarMensagem(`O recebimento do material do laudo ${props.detalhes.laudo} ainda não foi realizado ou finalizado`);
        modalConfirmarType.current = ('ok');
        modalConfirmarClick.current =  '1';
        setmodalConfirmar(true);
        break

      case '8':
        componente = <ExamesEmAbertoContainer />;
        titulo = intl.formatMessage({ id: "dashboards.examDetails.openExamReport" });
        setmodalConteudo(componente);
        setmodalTitulo(titulo);
        setmodalVisivel(true);
        setmodalSize(size);
        eventoNovaNotaRef.current = undefined;
        eventoModalConfirmar.current = undefined;
        break;

      default:
        componente = undefined;
        break;
    }
  }

  function closeModal() {
    setmodalVisivel(false)
    props.actions.selectNota(false);
  }

  function confirmModal() {
    const frame = document.getElementById('iframe-editor');
    if (frame !== null) {
      frame.style.display = 'block';

      const textRtf = props.nota.rtf;
      const idRtf = props.nota.id;

      props.editorActions.editorRtf(textRtf);
      props.editorActions.idRtf(idRtf);
      props.commonActions.preencherIdRtf(idRtf);

      props.commonActions.atualizarDetalhes({
        ...props.detalhes,
        medNotas: props.nota.medicoExecutante,
        revisorNotas: props.nota.medicoRevisor
      });

      if (!textRtf) {
        props.commonActions.showFadeCarregando(false);
      } else {
        frame.contentWindow.postMessage(
          {
            method: 'clearDocument'
          },
          editorUrl
        );
        frame.contentWindow.postMessage(
          {
            method: 'substituirTexto',
            text: textRtf,
            type: 'rtf',
            runat: editorRunat,
            breakLine: false,
            cleanBefore: true
          },
          editorUrl
        );
      }
    }
    setmodalVisivel(false);
    props.actions.selectNota(false);
  }

  function novaNota() {
    const frame = document.getElementById('iframe-editor');

    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'clearDocument'
        },
        editorUrl
      );
      setfabNotas(props.editor.textRtf !== '' || props.selectNota)
      props.editorActions.idRtf(0);
      props.commonActions.preencherIdRtf(0);
      props.commonActions.preencherIdRtf(0);
      props.editorActions.editorRtf('');
      props.commonActions.atualizarDetalhes({
        ...props.detalhes,
        medNotas: null,
        revisorNotas: null
      });
      setmodalVisivel(false);
      props.actions.selectNota(false);
    }
  }

  function cancelamentoEtapa() {
    setshowModalCancelamento(true);
  }

  function toggleModalCancelamento() {
    setshowModalCancelamento(false);
  }

  function cancelarEtapa() {
    props.commonActions.showFadeCarregando(true);
    const listagem = [...props.listagemCommon];
    const listagemIndex = listagem.findIndex(
      (item) => item.laudo === props.detalhes.laudo
    );
    if (listagemIndex >= 0) {
      listagem[listagemIndex].dataLiberacao = '';
      listagem[listagemIndex].isLaudoLiberado = false;
      listagem[listagemIndex].isLiberadoParcial = false;
      listagem[listagemIndex].isLiberadoTotal = false;
      props.commonActions.preencherListagem(listagem);
    }
    NotasAPI.cancelamentoNotas(
      props.detalhes.laudo,
      justificativaCancelar
    )
      .then(res => {
        WebapiCommon.obterStatusEtapasLaudo(props.detalhes.laudo).then(
          etapas => {
            props.commonActions.atualizarStatusDasEtapasDoLaudo(
              etapas,
              props.detalhes.laudo
            );
            props.commonActions.showEditor(false);
            props.commonActions.showFadeCarregando(false);
            toggleModalCancelamento();
            _fechar();
          }
        );
      })
      .catch(err => {
        props.commonActions.showFadeCarregando(false);
        toggleModalCancelamento();
      });
  }

  function verificarLaudar(status) {
    let material = props.detalhes.etapas.find(
      e => e.etapa === etapasEnum.MATERIAL
    );
    let conclusao = props.detalhes.etapas.find(
      e => e.etapa === etapasEnum.CONCLUSAO
    );

    if (material.status !== statusEtapasEnum.REALIZADO) {
      return showModal('7');
    }

    if (
      (props.exameFinalizado ||
        conclusao.status === statusEtapasEnum.REALIZADO) &&
      status === 'concluir'
    ) {
      return showModal('2');
    } else if (
      (props.exameFinalizado ||
        conclusao.status === statusEtapasEnum.REALIZADO) &&
      status === 'pendente'
    ) {
      return showModal('3');
    }

    if (status === 'concluir') {
      laudar(false, false);
    } else {
      laudar(true, false);
    }
  }

  const encaminharSegundaOpiniao = () => {
    setModalEncaminhar(!modalEncaminhar)
  }

  function construirBotoes() {
    let botoes = [];

    botoes.push({
      backgroundColor: '#4375A3',
      className: 'mv-basico-imprimir',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.reports.printOut' }),
      onClick: () => editor.Imprimir(props.commonActions)
    });

    botoes.push({
      backgroundColor: '#3f8642',
      label: '2',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.referral.referral' }),
      onClick: () => encaminharSegundaOpiniao(),
    });

    if (acessoPermitido(props.usuario, acessos.ExamesEmAberto))
    {
      botoes.push({
        backgroundColor: '#17a2b8',
        className: 'fas fa-flask',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetails.openExams' }),
        totalizador: props.quantidadeLaudosEmAberto,
        onClick: () => {
          showModal('8');
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Notas) &&
      (props.textRtf || fabNotas)
    ) {
      botoes.push({
        label: `${labelNotas.charAt(0).toUpperCase()}`,
        backgroundColor: '#f44336',
        color: '#ffffff',
        texto: `${labelNotas}`,
        onClick: () => {
          showModal('1');
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Notas) &&
      acessoPermitido(props.usuario, acessos.Concluir)
    ) {
      botoes.push({
        backgroundColor: '#3f8642',
        className: 'fas fa-save',
        atalho: 'CTRL+ALT+L',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laud' }),
        onClick: () => {
          laudarType.current = ('concluir')
          verificaEditor();
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.Notas) &&
      acessoPermitido(props.usuario, acessos.ConcluirPendente)
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'far fa-save',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.laudPendent' }),
        onClick: () => {
          laudarType.current = ('pendente')
          verificaEditor();
        }
      });
    }

    if (
      acessoPermitido(props.usuario, acessos.CancelamentoNotas) &&
      notasFinalizada
    ) {
      botoes.push({
        backgroundColor: '#b81717',
        className: 'mv-basico-cancelar',
        color: '#ffffff',
        texto: props.intl.formatMessage({ id: 'dashboards.examDetail.Cancellation' }),
        atalho: 'CTRL+ALT+N',
        onClick: () => {
          setshowModalCancelamento(!showModalCancelamento);
        }
      });
    }

    botoes.push({
      backgroundColor: '#bbbbbb',
      label: 'F',
      color: '#ffffff',
      texto: props.intl.formatMessage({ id: 'dashboards.examDetail.close' }),
      onClick: () => {
        fechar();
      }
    });

    return botoes;
  }

  useEffect(() => {
		if (textoEditor !== undefined && verificarTexto) {
			setVerificarTexto(false);
			props.commonActions.showFadeCarregando(true);
			if (!textoEditor || textoEditor.trim() === '') {
				props.commonActions.showFadeCarregando(false);
				return showModal('6');
			}
      props.commonActions.showFadeCarregando(false);
				return verificarLaudar(laudarType.current);
    }
    props.commonActions.showFadeCarregando(false);

	}, [textoEditor, verificarTexto]);

  function verificaEditor() {
    props.commonActions.showFadeCarregando(true);
    const frame = document.getElementById('iframe-editor');

    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'recuperarTextoRtfAndPlainText',
          urlHost: editorUrl,
          args: {
            action: 'getPlainText'
          }
        },
        editorUrl
      );
    }

    setTimeout(() => {
			props.commonActions.showFadeCarregando(false);
			return setVerificarTexto(true);
		}, 200);

  }

  function laudar(pendente, concluir) {
    const status = pendente
      ? statusEtapasEnum.PENDENTE
      : statusEtapasEnum.REALIZADO;
    props.editorActions.ChangeStatus(status);
    laudarEtapa(pendente, concluir);

  }

  function laudarEtapa(pendente, concluir) {
    let laudarEtapaRequest = {
      ...props.laudarEtapaRequest,
      pendente: pendente,
      concluirLaudo: concluir,
      medicoEtapa: props.editor.medExecutante,
      medicoRevisor: props.editor.medRevisor
    };

    let revisor = laudarEtapaRequest.medicoRevisor;
    let exec = laudarEtapaRequest.medicoEtapa;

    const usuarioLocal = JSON.parse(
      localStorage.getItem(LOCAL_STORAGE_USUARIO)
    );

    if (!usuarioLocal.medicoId && !pendente) {
      props.commonActions.showAlerta(
        'erro',
        intl.formatMessage({id:"dashboards.examDetail.onlyDoctors"}),
        2000
      );
      return;
    }

    if (!exec) {
      showModal('4');
      return;
    }

    if (!pendente && !revisor) {
      showModal('5');
      return;
    }

    props.editorActions.ChangeMedExecutante(exec);
    props.editorActions.ChangeMedRevisor(revisor);

    if (usuarioLocal.isResidente && !pendente) {
      setmodalAutorizacaoLaudar(true);
      setcallbackAutorizar({
        sucesso: medico_autorizou => {
          setmodalAutorizacaoLaudar(false);
          editarMedico(medico_autorizou);
          props.commonActions.argumentosSalvarEtapaLaudo(
            laudarEtapaRequest
          );
          editor.laudar(props.commonActions);
          props.commonActions.showAlerta(
            'sucesso',
            intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
            2000
          );
        },
        error: () => {
          props.commonActions.showAlerta(
            'erro',
            intl.formatMessage({id:"dashboards.examDetail.notAllowed"}),
            2000
          );
        }
      })
    } else {
      props.commonActions.argumentosSalvarEtapaLaudo(laudarEtapaRequest);
      editor.laudar(props.commonActions);
      props.commonActions.showAlerta(
				'sucesso',
				intl.formatMessage({id:"dashboards.examDetail.reportSave"}),
				2000
			);
    }
  }

  function alterarVisibilidadeAbas(propriedadeNoEstado) {
    const visibilidade = !props[propriedadeNoEstado];
    const larguraEditor = visibilidade
      ? 'calc(100% - 33.333333% - 10px)'
      : '100%';
    props.commonActions.alterarVisibilidadeAbas({
      [propriedadeNoEstado]: visibilidade
    });
    props.commonActions.atualizarLarguraEditor(larguraEditor);
  }

  return (
    <React.Fragment>
      <ModalEncaminhar
        toggleModalEncaminhar={() => setModalEncaminhar(!modalEncaminhar)}
        type={modalEncaminharType}
        showModalEncaminhar={modalEncaminhar}
        titulo={'Encaminhar'}
        mensagem={'Encaminhar'}
        confirmar={() => setModalEncaminhar(!modalEncaminhar)}
        laudo={props.detalhes.laudo}
        commonActions={props.commonActions}
      />
      <ModalConfirmar
        toggleModalConfirmar={() => setmodalConfirmar(!modalConfirmar)}
        type={modalConfirmarType.current}
        showModalConfirmar={modalConfirmar}
        titulo={modalConfirmarTitulo}
        mensagem={modalConfirmarMensagem}
        confirmar={()=>{
          if(modalConfirmarClick.current === '2'){
            laudar(true, false);
          }else if(modalConfirmarClick.current === '3'){
            laudar(false, true);
          };
          fecharModalConfirmar();
        }
        }

        //onConfirmar={modalConfirmarClick}
        /*
        confirma={props.confirmModal}
        disabled={!props.modalBtnConfirmar}
        novo={props.novaNota}
        */
      />
      <NotasPage
        usuario={props.usuario}
        modalVisivel={modalVisivel}
        modalTitulo={modalTitulo}
        modalConteudo={modalConteudo}
        modalSize={modalSize}
        modalBtnConfirmar={props.selectNota}
        closeModal={(e) => closeModal(e)}
        confirmModal={eventoModalConfirmar.current}
        novaNota={eventoNovaNotaRef.current}
        detalhes={props.detalhes}
        construirBotoes={construirBotoes()}
        acessoPermitido={acessoPermitido}
        altura={window.innerHeight - props.altura - 214}
        alterarFullscreen={(e) => alterarFullscreen(e)}
        modalAutorizacaoLaudar={modalAutorizacaoLaudar}
        callbackAutorizar={callbackAutorizar}
        showModalCancelamento={showModalCancelamento}
        toggleModalCancelamento={(e) => toggleModalCancelamento(e)}
        cancelarEtapa={(e) => cancelarEtapa(e)}
        justificativaCancelar={justificativaCancelar}
        setJustificativa={(e) => setJustificativa(e)}
        fecharModalAutorizacao={() => setmodalAutorizacaoLaudar(false)}
        notasFinalizada={notasFinalizada}
        showModalConfirmacaoCancelamento={(e) => cancelamentoEtapa(e)}
        // modalIsOpen={showModalConfirmarCancelamento}
        showModalConfirmarCancelamento={showModalConfirmarCancelamento}
        toggleModalConfirmarCancelamento={(e) => toggleModalConfirmarCancelamento(e)}
        cancelarEtapas={(e) => cancelarEtapasPosteriores(e)}
        alterarVisibilidadeAbas={(e) => alterarVisibilidadeAbas(e)}
        visibilidadeListaLaminas={props.visibilidadeListaLaminas}
        visibilidadeAutotexto={props.visibilidadeAutotexto}
        visibilidadeListagemAnexo={props.visibilidadeListagemAnexo}
        visibilidadeLaudosAnteriores={props.visibilidadeLaudosAnteriores}
        visibilidadeHistoricoLaudo={props.visibilidadeHistoricoLaudo}
        quantidadeLaudosAnteriores={props.quantidadeLaudosAnteriores}
      />
    </React.Fragment>
  );
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch),
    editorActions: bindActionCreators(editorActions, dispatch)
  };
};

const mapStateToProps = state => {
  return {
    editor: state.editor,
    usuario: state.usuario,
    nota: state.notas.nota,
    selectNota: state.notas.selectNota,
    textRtf: state.editor.textRtf,
    altura: state.commonReducer.altura,
    detalhes: state.commonReducer.detalhes,
    editorInicializado: state.commonReducer.editorInicializado,
    laudarEtapaRequest: state.commonReducer.laudarEtapaRequest,
    listagem: state.commonReducer.listagem,
    exameFinalizado: state.commonReducer.exameFinalizado,
    visibilidadeListaLaminas: state.commonReducer.visibilidadeListaLaminas,
    etapaAtual: state.commonReducer.etapa.etapa,
    visibilidadeAutotexto: state.commonReducer.visibilidadeAutotexto,
    visibilidadeLaudosAnteriores:
      state.commonReducer.visibilidadeLaudosAnteriores,
    visibilidadeListagemAnexo: state.commonReducer.visibilidadeListagemAnexo,
    visibilidadeHistoricoLaudo: state.commonReducer.visibilidadeHistoricoLaudo,
    quantidadeLaudosAnteriores: state.commonReducer.quantidadeLaudosAnteriores,
    quantidadeLaudosEmAberto: state.commonReducer.quantidadeLaudosEmAberto
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(NotasContainer);


// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/notas/notas.container.js